export const SOURCES_PERMISSIONS = {
  general: {
    read: 'sources.read',
    create: 'sources.create',
    update: 'sources.update',
    delete: 'sources.delete'
  },
  reconciliation: {
    read: 'sources.conciliacion.read',
    create: 'sources.conciliacion.create',
    update: 'sources.conciliacion.update',
    delete: 'sources.conciliacion.delete'
  },
  sourceRecords: {
    read: 'sources.source-records.read',
    create: 'sources.source-records.create',
    update: 'sources.source-records.update',
    delete: 'sources.source-records.delete'
  },
  posTransactions: {
    read: 'sources.pos-transacciones.read',
    create: 'sources.pos-transacciones.create',
    update: 'sources.pos-transacciones.update',
    delete: 'sources.pos-transacciones.delete'
  },
  posClosures: {
    read: 'sources.pos-cierres.read',
    create: 'sources.pos-cierres.create',
    update: 'sources.pos-cierres.update',
    delete: 'sources.pos-cierres.delete'
  },
  aggregators: {
    read: 'sources.agregadores.read'
  },
  acquirings: {
    read: 'sources.adquiriencias.read'
  }
} as const;
